export default __webpack_public_path__ + "static/media/contextual-chocolate@3x.e65b619f.png";